/**
 * Where an invalid `/:lang` URL goes. A locale-looking prefix ("/fr/dashboard") is
 * replaced; anything else is a path that lost its prefix ("/auth", from a bare
 * navigate("/auth")) and gets the visitor's language in front, so it still reaches
 * its page instead of the landing page. Query and hash are kept (invite tokens).
 */
export function localizedRedirect(
  location: { pathname: string; search: string; hash: string },
  language: string
): string {
  const [, first = "", ...rest] = location.pathname.split("/");
  const tail = /^[a-z]{2}$/i.test(first) ? rest : [first, ...rest];
  const path = tail.filter(Boolean).join("/");
  return `/${language}${path ? `/${path}` : ""}${location.search}${location.hash}`;
}
